module.exports = __webpack_public_path__ + "img/twitter.86f9362d.svg";